/** TaxiAppz Pro Plus — Play Store privacy & delete-account copy. */
export const PLATFORM_PRIVACY_MARKDOWN = `
# TaxiAppz Pro Plus - Privacy Policy

**Last updated:** 2026-08-08

This Privacy Policy applies to everyone who uses TaxiAppz Pro Plus mobile apps and related services — customers, drivers, delivery partners, service providers, and vendors.

## 1. Who we are
We operate the TaxiAppz Pro Plus ecosystem, which includes TaxiAppzProPlusUser, TaxiAppzProPlusPartner, TaxiAppzProPlusProvider, and TaxiAppzProPlusVendor, apps that provide transport, delivery, on-demand services, and related features. By using any of these apps you agree to this policy.

## 2. Information we collect
- Account details: name, phone number, email, profile photo (if provided)
- Location: when you use maps, rides, delivery, or on-demand booking (with permission)
- Usage & device: app version, device type, IP address, crash/log data for security and reliability
- Transactions: trips, orders, bookings, payments, and support history needed to run the service

## 3. How we use information
- To create and manage your TaxiAppz Pro Plus account
- To provide rides, deliveries, bookings, and support
- To match customers with drivers, partners, or providers
- To process payments and prevent fraud
- To improve safety, performance, and product quality
- To meet legal and regulatory requirements

## 4. Sharing of information
We share information only when needed:
- With drivers, merchants, or providers to complete your request
- With payment processors and infrastructure partners
- When required by law, regulators, or valid legal process

We do not sell your personal information.

## 5. Data retention
We keep account and transaction data while your account is active, and longer where required for law, tax, disputes, or safety. After you delete your account we remove or anonymize personal data that is no longer needed.

## 6. Your choices
- Update profile details in the app
- Control location and notification permissions on your device
- Request account deletion via our Delete Account page

## 7. Children's privacy
TaxiAppz Pro Plus is not directed to children under the age required by local law. We do not knowingly collect personal data from children.

## 8. Security
We use reasonable technical and organizational measures to protect your data. No method of transmission or storage is 100% secure.

## 9. Changes
We may update this policy from time to time. The "Last updated" date at the top will change when we do. Continued use of the app means you accept the updated policy.

## 10. Contact
For privacy questions or requests, contact us at nplustech14@gmail.com or use in-app support.
`.trim();

export const PLATFORM_DELETE_HELP =
  'Enter the phone number or email you used to sign up in the app. We will send a one-time verification code. After you confirm, we permanently close matching TaxiAppz Pro Plus accounts (TaxiAppzProPlusUser, TaxiAppzProPlusProvider, TaxiAppzProPlusPartner, TaxiAppzProPlusVendor). You will lose access to the apps linked to that phone or email. Some anonymized trip or order records may be kept where required by law or for safety.';

export const PLATFORM_DELETE_APPLIES_TO =
  'Applies to: TaxiAppzProPlusUser, TaxiAppzProPlusProvider, TaxiAppzProPlusPartner, TaxiAppzProPlusVendor';

export const PLATFORM_SUPPORT_EMAIL = 'nplustech14@gmail.com';

export const PLATFORM_BRAND = 'TaxiAppz Pro Plus';
